import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  mainDrawer: {
    backgroundColor: theme.palette.background.paper,
    width: 450,
    "& .MuiTab-root": { minWidth: "140px" },
    "& .MuiTabs-indicator": { backgroundColor: "#0B3C5D !important" },
  },
  DrawerTabs: {
    "& .MuiTabs-indicator": { display: "none" },
    "& .Mui-selected": {
      color: "#282C33",
      "& .MuiTab-wrapper": {
        backgroundColor: "#FFFFFF",
        width: "auto",
        color: "black",
        paddingLeft: "20px",
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingRight: "17px",
        borderRadius: "5px",
        boxShadow: "0px 1px 1px #2929293D",
      },
    },
  },
  drawerDetails: {
    "& .topContainer": {
      border: "1px solid #D5DCE1",
      padding: "10px",
      marginBottom: "20px",
      marginTop: "20px",
    },
    "& .heading": {
      fontWeight: "bold",
      fontSize: "15px",
      marginBottom: "-5px",
      marginTop: " 10px",
      marginLeft: "-4px",
    },
    "& .headingHistory": {
      fontWeight: "bold",
      fontSize: "15px",
      marginBottom: "-5px",
      marginTop: " 10px",
      marginLeft: "-4px",
    },
    "& .headingHistoryTrail": {
      marginLeft: "0",
    },
    "& .subHeading": { fontSize: "12px" },
    "& .subHeadingDetails": {
      fontSize: "12px",
      fontWeight: "bold",
      wordWrap: "break-word",
    },
    "& .itemRow": { margin: "5px 0px 5px 0px" },
    "& .topContainerTrail": {
      padding: "10px",
      marginBottom: "10px",
      marginTop: "10px",
    },
    "& .topContainerTrailLastDiv": {
      padding: "10px",
      marginBottom: "-20px",
      marginTop: "10px",
    },
    "& .itemRowTrail": {
      margin: "5px 0px 5px 0px",
    },
  },
}));
